export class ModalOverlayDataModel {
  constructor(public title: string, public description?: string) {}
}
